export const headers = [
    { field: "id", headerName: "ID", width: 70, hidden: true },
    { field: "depa_codigo", headerName: "Codigo", width: 90 },
    { field: "depa_descripcion", headerName: "Descripcion", width: 230 },
    { field: "prov_descripcion", headerName: "Provincia", width: 130 },
    { field: "mostrar", headerName: "Visibilidad", width: 130 },

  ];
  